module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Chat4-e469a65b1fe38a90c18410c77983ea38.svg";